import { Controller } from "@hotwired/stimulus"

// The Create New Form slideover's three-way start (TASK-266.2): Describe It
// · Start Blank · From the Library. Each choice has its own Continue (a
// link to the describe page, this controller's showBlank, or the template
// library modal), and only the chosen one shows. Start Blank swaps the
// chooser for today's name form in place, with no request.
export default class extends Controller {
  static targets = ["chooser", "blank", "continue"]

  choose(event) {
    const value = event.target.value
    this.continueTargets.forEach((button) => {
      button.hidden = button.dataset.formStartOption !== value
    })
  }

  showBlank(event) {
    event.preventDefault()
    this.chooserTarget.hidden = true
    this.blankTarget.hidden = false
    const first = this.blankTarget.querySelector("input[type=text], textarea")
    if (first) first.focus()
  }
}
